<template>
  <div class="container">
    <p class="">时间段设置</p>
    <div class="select_flag_div mt16">
      <div class="setting-item mt16">
        <cx-select title="开始日期" :selectOptions="flagLists" :value.sync="startDateFlag" />
      </div>
      <div class="setting-item mt16">
        <cx-select title="结束日期" :selectOptions="flagLists" :value.sync="endDateFlag" />
      </div>
    </div>
  </div>
</template>
<script>
import { UpdateLayoutData } from "utils/updateData/layout/layoutComponentUpdateData.js"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
export default {
  props: {
    options: Object
  },
  computed: {
    startDateFlag: {
      get() {
        return this.options.startDateFlag
      },
      set(val) {
        this.$changeOptionsEV(val, "startDateFlag", false)
      }
    },
    endDateFlag: {
      get() {
        return this.options.endDateFlag
      },
      set(val) {
        this.$changeOptionsEV(val, "endDateFlag", false)
      }
    },
  },
  data() {
    return {
      flagLists: []
    }
  },
  mounted() {
    if (this.$store.state[this.request_prefix].page.pluginName?.includes("listPagePlugin")) {
      const rectAttr = this.findComponent('emptyLayoutComponent')
      this.getFields(rectAttr)
      this.getFields()
    } 
    if (this.$store.state[this.request_prefix].page.pluginName?.includes("subPagePlugin")) {
      this.getFieldsNew()
    }
  },
  methods: {

    async getAppointDataEv(rectAttr, isAutoLayoutComp) {
      const { websiteId, pageId, wfwfid } = this.$store.state.states.getDataPageIds
      let rectAttr1 = rectAttr.options
      if(isAutoLayoutComp){
        rectAttr1 = rectAttr
      }
      const appId = rectAttr1.appId ? rectAttr1.appId : rectAttr1.myFetchParam.appId
      return await getAppointCacheData.call(
        this,
        pageId,
        wfwfid,
        websiteId,
        appId,
        { useSubPageQuery: rectAttr1.useSubPageQuery, selectedDetailParam: rectAttr1.selectedDetailParam }
      )
    },    
    async getFields(rectAttr) {
      const { cacheDataTypes, restDataUrl } = await this.getAppointDataEv(rectAttr, false)
        let { activeIndex } = rectAttr.options
        const updateLayoutData = new UpdateLayoutData(this)
        let ids1 = {
          container_id: rectAttr.container_id,
          rect_id: rectAttr.rect_id
        }
        const { completeData } = await updateLayoutData.upDateRect({
          activeIndex,
          rectAttr,
          cacheDataTypes,
          restDataUrl,
          ids: ids1,
          categoryMode: rectAttr?.options?.categoryMode
        })
        //获取匹配信息
        this.flagLists = []
        if (completeData.length > 0) {
          for (let j in completeData[0]) {
            if (completeData[0][j].key) {
              this.flagLists.push({
                value: j,
                label: completeData[0][j].key
              })
            }
          }
        }
    },
    async getFieldsNew() {
        const completeData = JSON.parse(window.localStorage.getItem("completeData"))
        //获取匹配信息
        this.flagLists = []
        if (completeData.length > 0) {
          for (let j in completeData[0]) {
            if (completeData[0][j].key) {
              this.flagLists.push({
                value: j,
                label: completeData[0][j].key
              })
            }
          }
        }
    },
    findComponent(type) {
    // 因为简单搜索组件也是自由布局组件，所以需要排除掉
      return this.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
        return rect.shape === type && !rect.options?.pluginName?.includes("searchComponentPlugin")
      })[0]
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  padding: 16px;
  color: var(--textColor);
}
.select_flag_div {
  border: 1px solid #e9e9e9;
  padding: 0 10px 10px;
  background-color: #fbfcfd;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
</style>